import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'eg-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss'],
  standalone: false,
})
export class DropdownButtonComponent {
  @Input() items: MenuItem[];
  @Input() loading = false;
  @Input() disabled = false;
}
